import { trimEnd } from 'lodash';
export const limitLength = (text = '', length) => text.substring(0, length);
export const removeTrailingSlash = (text) => trimEnd(text, '/');
//# sourceMappingURL=utils.js.map